exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] ._3j2y1iyUUAEuHFCJ6bCWa4{margin-left:2px}html[dir=rtl] ._3j2y1iyUUAEuHFCJ6bCWa4{margin-right:2px}._iB8nGrdAIPIKt66ks8iN{font-weight:600}html[dir=ltr] ._iB8nGrdAIPIKt66ks8iN{padding-right:3px}html[dir=rtl] ._iB8nGrdAIPIKt66ks8iN{padding-left:3px}._3DTEJWAIOZt0FE-S67c7J5{display:inline}", ""]);

// exports
exports.locals = {
	"wellTrailingComponent": "_3j2y1iyUUAEuHFCJ6bCWa4",
	"label": "_iB8nGrdAIPIKt66ks8iN",
	"divFixer": "_3DTEJWAIOZt0FE-S67c7J5"
};